// formatCardData.js
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined"; // Total Views
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined"; // Clicks
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined"; // Total Applicants
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined"; // Number of Creator

const iconList = [
  AssignmentOutlinedIcon,
  CalendarTodayOutlinedIcon,
  EventBusyOutlinedIcon,
  GroupOutlinedIcon,
];

// 🌈 pick whatever colors you like here
const iconColors = ["#595BD4", "#D8A353", "#D85B53", "#34A853"];

export function formatCardData(data) {
  return data.map((item, index) => ({
    label: item.label,
    value: item.count,
    Icon: iconList[index] || null,
    cardbg: "#FFFFFF",
    iconColor: iconColors[index] || "#4F46E5",
    bgcolor: item.bgcolor || "#F5F7FF",
  }));
}




export const getCurrentMonthAndWeek = () => {
  const today = new Date();
  const month = today.getMonth() + 1; // Months are 0-based, so add 1
  const day = today.getDate();

  // Get the first day of the current month
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

  // Calculate week of the month (1-based)
  const week = Math.ceil((day + firstDay.getDay()) / 7);

  return { month, week };
};

const dayOrder = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const transformData = (apiData) => {
  const dayWiseClicks = {};

  // Initialize all days with 0 clicks
  dayOrder.forEach(day => {
    dayWiseClicks[day] = 0;
  });

  // Aggregate clicks per day
  Object.values(apiData).forEach(week => {
    Object.entries(week.day_wise).forEach(([day, clicks]) => {
      dayWiseClicks[day] += clicks;
    });
  });

  // Convert to array format
  return dayOrder.map(day => ({
    day: day.slice(0, 3), // Convert to "Mon", "Tue", etc.
    value: dayWiseClicks[day]
  }));
};